// Exponential backoff + jitter for websocket reconnects: a backend restart
// must not make every client reconnect in lockstep every 5s (the
// react-use-websocket default of 20 fixed-interval attempts).
export const WS_RECONNECT = {
  reconnectAttempts: 20,
  reconnectInterval: (attempt: number) =>
    Math.min(30_000, 1_000 * 2 ** attempt) + Math.random() * 1_000,
};
